import React from 'react';
import {WideHeader} from '../../layout/wide';

const MCBW: React.FC = () => {
  return (
    <>
      <WideHeader
        title="Międzyuczelniane Centrum Badań Witrażowych"
        introduction="Interuniversity Centre for Stained Glass Research"
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm p-6">
            <img
              src="/images/partners/mcbw.svg"
              alt="MCBW Logo"
              className="mr-10 mb-4 w-64 h-auto"
            />

            <div className="text-gray-700 leading-relaxed space-y-4">
              <p>
                Międzyuczelniane Centrum Badań Witrażowych powołane zostało do istnienia jako konsorcjum naukowe na podstawie umowy zawartej w dniu 9 maja 2017 roku przez rektorów Uniwersytetu Jagiellońskiego i Akademii Sztuk Pięknych w Krakowie. Celem jego działania jest inicjowanie, organizowanie, prowadzenie i koordynowanie różnych form aktywności naukowej w zakresie interdyscyplinarnych badań nad sztuką witrażową, promowanie prac naukowo-badawczych w tym zakresie, prowadzenie działalności eksperckiej, oświatowej i edukacyjnej dotyczącej witraży, w tym gromadzenie zasobów elektronicznych i innych źródeł. Działania Centrum prowadzone będą w oparciu o standardy i wytyczne opracowane przez Corpus Vitrearum International. Do zadań Centrum Badań Witrażowych należy:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>współpraca z Corpus Vitrearum International i Polskim Komitetem Narodowym Corpus Vitrearum;</li>
                <li>współpraca z podmiotami zewnętrznymi w ramach grantów i projektów badawczych finansowanych ze źródeł krajowych, europejskich i międzynarodowych;</li>
                <li>prowadzenie badań mających na celu rozwój interdyscyplinarnych studiów nad sztuką witrażową;</li>
                <li>współpraca ze służbami konserwatorskimi, osobami prawnymi i fizycznymi, w szczególności prowadzącymi działalność konserwatorską i witrażowniczą oraz będących właścicielami obiektów w zakresie działań mających na celu wdrażanie i doskonalenie metod ochrony, konserwacji i metod badawczych w zakresie sztuki witrażowej;</li>
                <li>współpraca z jednostkami Uniwersytetu Jagiellońskiego i Akademii Sztuk Pięknych oraz ośrodkami naukowo-badawczymi w Polsce i za granicą w zakresie studiów nad sztuką witrażową;</li>
                <li>promowanie badań krajowych i zagranicznych w zakresie studiów nad sztuką witrażową; pozyskiwanie funduszy na badania dotyczące problematyki witrażowej.</li>
              </ul>

              <p>
                Zadania te są realizowane w szczególności poprzez: prowadzenie badań naukowych, publikacje związane z tematyką witrażową, prowadzenie baz danych dotyczących witraży, organizowanie i prowadzenie wykładów, seminariów, konferencji naukowych, publikowanie ekspertyz i analiz dotyczących problematyki konserwatorskiej witraży oraz organizowanie wydarzeń kulturalnych, w szczególności wystaw związanych ze sztuką witrażową. Siedziba Centrum znajduje się w Instytucie Historii Sztuki UJ, zaś część konserwatorska afiliowana jest przy Wydziale Konserwacji i Restauracji Dzieł Sztuki ASP. Na kierownika Centrum powołany został prof. dr hab. Wojciech Bałus.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MCBW;

